import { Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Spacer } from 'theSource/components';
import { OverlineWithSubtext } from '../OverlineWithSubtext';
import {
  ContentDetailsBoxStyled,
  DetailsBoxStyled,
  ContentDetailsWrapperStyled,
  ItemLabelStyled,
} from './ContentDetailsBoxStyled';

export interface ContentDetailsBoxProps {
  label?: string;
  inNetworkValue?: string;
  outOfNetworkValue?: string;
  preferredNetwork?: string;
  text?: string;
}

export const ContentDetailsBox = ({
  label,
  inNetworkValue,
  outOfNetworkValue,
  preferredNetwork,
  text,
}: ContentDetailsBoxProps) => {
  const { t } = useTranslation('pages.benefits');
  const networkValues = inNetworkValue || outOfNetworkValue || preferredNetwork;

  if (!label || (!networkValues && !text)) {
    return null;
  }

  return (
    <ContentDetailsWrapperStyled>
      <ContentDetailsBoxStyled data-testid="plan-details-content-box">
        <DetailsBoxStyled>
          <ItemLabelStyled component="div" variant="body2">
            {label}
          </ItemLabelStyled>
        </DetailsBoxStyled>
        <DetailsBoxStyled>
          {networkValues && <Spacer height={2} />}
          {inNetworkValue && (
            <OverlineWithSubtext
              title={t('inNetWorkLabel')}
              subtext={inNetworkValue}
              subtextAsHeading
            />
          )}
          {outOfNetworkValue && (
            <OverlineWithSubtext
              title={t('outOfNetWorkLabel')}
              subtext={outOfNetworkValue}
              subtextAsHeading
            />
          )}
          {preferredNetwork && (
            <OverlineWithSubtext
              title={t('preferredNetWorkLabel')}
              subtext={preferredNetwork}
              subtextAsHeading
            />
          )}
          {!networkValues && text && (
            <ItemLabelStyled component="div" variant="body2Heading">
              {text}
            </ItemLabelStyled>
          )}
        </DetailsBoxStyled>
      </ContentDetailsBoxStyled>
      <Spacer height={3} />
      <Divider />
    </ContentDetailsWrapperStyled>
  );
};
